













































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import delNonNumCode from '@/utils/delNonNumCode'

@Component
export default class AppTextField extends Vue {
  @Prop({ type: [Number, String] }) readonly value!: number | string
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String, default: 'text' }) readonly type!: string
  @Prop({ type: String }) readonly confirm!: string
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: Boolean, default: true }) readonly delay!: boolean
  @Prop({ type: Boolean, default: false }) readonly showWarning!: boolean

  model = ''

  showPWD = false

  validRules = []

  rules = {
    required: (value:string | number) => !!value || value === '0' || value === 0 || 'Required.',
    text: (value: string) => true,
    email: (value: string) => {
      if (!value) {
        return true
      }
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Invalid e-mail'
    },
    password: (value: string) => {
      if (!value && !this.required) return true
      return value.length >= 6 || 'Min 6 characters'
    },
    confirm: (value: string) => value === this.confirm || 'Passwords entered twice are inconsistent',
    number: (value: string) => {
      return !isNaN(Number(value)) || 'Only numbers allowed'
    },
    phone: (value: string) => {
      if (!value) {
        return true
      }
      const pureVal = delNonNumCode(value)
      const pattern = new RegExp(/^\d{10}$/, 'g')
      return pattern.test(pureVal) || 'Invalid phone number'
    },
    currency: (value: string) => {
      if (!value) {
        return true
      }
      return /^(([0-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(value) || 'Only numbers below two decimal places allowed'
    },
    formPassword: (value: string) => true
  }

  mounted () {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(this.value ? this.value + '' : '')
    } else if (this.type === 'number') {
      this.model = this.value ? this.value + '' : '0'
    } else {
      this.model = this.value ? this.value + '' : ''
    }
  }

  blurHandler () {
    const { model } = this
    if (this.type === 'phone') {
      this.valueChangedHandler(this.convertPhoneType(model))
    }
  }

  convertPhoneType (val: string) {
    const pureVal = delNonNumCode(val)
    if (pureVal.length > 6) {
      const state = pureVal.substring(0, 3)
      const first = pureVal.substring(3, 6)
      const last = pureVal.substring(6)
      return `(${state}) ${first}-${last}`
    } else if (pureVal.length > 3) {
      const state = pureVal.substring(0, 3)
      const first = pureVal.substring(3)
      return `(${state}) ${first}`
    } else {
      return pureVal
    }
  }

  keyDownHandler (e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.searchHandler()
    }
  }

  @Emit('search')
  searchHandler () {}

  @Emit('input')
  valueChangedHandler (val: string) {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(val)
    } else {
      this.model = val
    }
    return val
  }

  @Watch('value')
  onValueChanged (val: string) {
    if (this.type === 'phone') {
      this.model = this.convertPhoneType(val)
    } else {
      this.model = val
    }
  }
}
